var _defs, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconGallery(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #006400;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55,405.5l-.4.4c-5.8-12.6-9.4-26.9-10.9-42.7,1.5,15.6,5.5,29.7,11.3,42.2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M192,221.4c28,0,50.8-22.7,50.8-50.8s-22.7-50.8-50.8-50.8-50.8,22.7-50.8,50.8,22.7,50.8,50.8,50.8Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M345.4,42.7h-178.8c-77.7,0-123.9,46.3-123.9,123.9v178.8c0,23.3,4.1,43.5,11.9,60.6,18.3,40.5,57.6,63.4,112,63.4h178.8c77.7,0,123.9-46.3,123.9-123.9v-178.8c0-77.7-46.3-123.9-123.9-123.9h0ZM434.6,266.7c-16.6-14.3-43.5-14.3-60.2,0l-88.7,76.2c-16.6,14.3-43.5,14.3-60.2,0l-7.3-6c-15.1-13.2-39.3-14.5-56.3-3l-79.8,53.5c-4.7-11.9-7.5-25.8-7.5-42v-178.8c0-60.2,31.8-91.9,91.9-91.9h178.8c60.2,0,91.9,31.8,91.9,91.9v102.4l-2.8-2.3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGallery);
export default __webpack_public_path__ + "static/media/icon_gallery.2748e6542000b98a506505415af35b19.svg";
export { ForwardRef as ReactComponent };